import { Plus } from "lucide-react";

export function FAB({ onClick, label = "Aggiungi", testid = "fab-add" }) {
    return (
        <button
            onClick={onClick}
            data-testid={testid}
            aria-label={label}
            className="fixed right-5 bottom-24 lg:bottom-10 lg:right-10 z-40 h-14 w-14 rounded-full bg-brand-gold text-brand-navy shadow-gold flex items-center justify-center hover:bg-brand-goldDark hover:scale-105 active:scale-95 transition-all duration-200"
        >
            <Plus size={24} strokeWidth={2.6} />
        </button>
    );
}
